module.exports = __webpack_public_path__ + "static/media/socourt-desktop-screens.7612558f.png";